<template>
  <div id="BtnSaveData">
    <hr />
    <button class="btn btn-success mr-5" @click.prevent="SaveDeta()"><i class="fad fa-plus ml-2"></i>ثبت اطلاعات</button>
    <button id="btnCancel" class="btn btn-warning m-2" @click.prevent="Cancel()"><i class="fad fa-times ml-2"></i>انصراف</button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      DataAxiosPost: {
        ArryfildValue: this.DataParanet,
        Method: 'post',
        Action: '',
        Token: this.$session.get('Token'),
        From: 'Body',
      },
      DataAddLogInformation: {
        ArryfildValue: {},
        Method: 'post',
        Action: 'UserLogInformation/b_AddRow',
        Token: this.$session.get('Token'),
      },
    }
  },
  methods: {
    SaveDeta() {
      if (this.$ValidForm(this.$route.name)) {
        if (this.$route.name == 'DetailTarifSematha') {
          this.DataAxiosPost.Action = 'TarifSematha' + '/' + 1 + ',' + this.$session.get('UserInfo').tblUserGrpId
        } else {
          if (this.$route.name.substring(0, 6) == 'Detail') {
            this.DataAxiosPost.Action = this.$route.name.substring(6)
          } else {
            this.DataAxiosPost.Action = this.$route.name
          }
        }

        this.DataAxiosPost.ArryfildValue = this.DataParanet
        this.$PostData(this.DataAxiosPost).then((data) => {
          if (data.status == 'Ok') {
            this.$emit('Success', true)
            // this.$mySweetPost('ثبت موفق', 'اطلاعات با موفقیت ثبت شد', 'success', 'ثبت و ادامه', 'بستن صفحه')
            document.getElementById('btnCancel').click()
            this.$store.state.renderComponentGrid = false
            this.$store.state.renderComponent = false

            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
              this.$store.state.renderComponent = true
            })
            this.$toasted.success('اطلاعات با موفقیت ثبت شد',{ duration: 3000})
            //#region ثبت رویداد های سیستم
            var object = this.$store.state.objectLogInformation
            object.UserId = this.$session.get('UserInfo').tblUserId
            object.UserNameFamily = this.$session.get('UserInfo').namFam
            object.FormId = this.$route.name.substring(6)
            object.tblShobeId = this.$session.get('UserInfo').tblShobeId
            object.FkId = data.returnId
            object.IsDelete = 0

            for (let index = 0; index < this.$session.get('Menu').length; index++) {
              const element = this.$session.get('Menu')[index]
              if (element.RouteName == object.FormId) {
                object.FormName = element.label
              }
            }
            this.$getLocalIP().then((res) => {
              object.IpAddress = res
            })

            this.DataAddLogInformation.ArryfildValue = object
            this.$PostData(this.DataAddLogInformation).then(() => {})
            //#endregion  ثبت رویداد های سیستم
            if (this.$route.name == 'DetailAlarm') {
              var UserAlarm = JSON.parse(this.$cookies.get('UserAlarm'))
              if (UserAlarm == null) {
                // console.log(data);
                let objAlarm = [
                  {
                    Id: data.Alldata.Id,
                    TblUserId: data.Alldata.TblUserId,
                    AlarmText: data.Alldata.AlarmText,
                    DateAlarm: data.Alldata.DateAlarm,
                    IsView: data.Alldata.IsView,
                    DateTimeInsert: data.Alldata.DateTimeInsert,
                    TblUserGrpIdInsert: data.Alldata.TblUserGrpIdInsert,
                    DateTimeLastEdit: data.Alldata.DateTimeLastEdit,
                    TblUserGrpIdLastEdit: data.Alldata.TblUserGrpIdLastEdit,
                  },
                ]
                this.$cookies.set('UserAlarm', JSON.stringify(objAlarm))
              } else {
                UserAlarm.push(data.Alldata)
                this.$cookies.set('UserAlarm', JSON.stringify(UserAlarm))
              }
            }
          } else {
            if (data.eNum == '2601') {
              this.$mySweetDefaultTost('خطایی رخ داده!', 'امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ', 'error', 3000)
            } else if (data.status == 'Not Ok') {
              this.$mySweetDefaultTost('خطایی رخ داده!', 'امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ', 'error', 3000)
            } else if (this.$route.name == 'azainfo'){
              if(data.eNum == '1010'){
              this.$mySweetDefaultTost('خطایی رخ داده!', 'امکان ثبت کدملی تکراری وجود ندارد. ورودی های خود را کنترل کنید ', 'error', 3000)
              }
            }
             else {
              this.$mySweetDefaultTost('خطایی رخ داده!', '', 'error', 3000)
            }
          }
        })
      }
    },
    Cancel() {
      if (this.ShowCancelButton == false) {
        this.$emit('Cancel', true)
      } else {

        this.$router.go(-1)
      }
    },
  },
  props: ['DataParanet', 'ShowCancelButton'],
}
</script>
<style scoped>
#BtnSaveData {
  left: 0;
}
</style>
